Vue.component('state-friends', {
    template: `
    <div class="vertical-center">
        <h4>Join us on Discord to find other players and give suggestions!</h4>
        <iframe src="https://discord.com/widget?id=860234109653221396&theme=dark" width="350" height="500" allowtransparency="true" frameborder="0" sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"></iframe>
        <br>
        <div>
            <a href="https://www.reddit.com/r/antwar/" target="_blank" class="app-social-button fa fa-reddit"></a>
            <a href="https://twitter.com/bombsightgames" target="_blank" class="app-social-button fa fa-twitter"></a>
        </div>
    </div>
    `
})